<template>
  <v-form ref="group" class="mt-6" autocomplete="off">
    <div class="d-flex justify-space-between align-center">
      <!-- <label class="modal-label">{{ $t("guest.company") }} </label> -->
      <label class="modal-label">{{ $t("group") }} </label>
      <v-btn @click="$emit('deleteGroup')" text class="modal-btn" v-if="!specialFlow && !$store.getters['app/isTenant']">{{
        $t("delete")
      }}</v-btn>
    </div>
    <v-combobox
      :value="group.group_name"
      @input.native="($event) => $emit('groupChangedHandler', $event.target.value ? $event.target.value : '')"
      @change="($event) => $emit('groupChangedHandler', $event ? $event : '')"
      :items="
        groups.filter((c) =>
          group.group_name ? c.toLowerCase().includes(group.group_name.toLowerCase()) : c
        )
      "
      attach
      class="modal-input"
      :label="$t('group_name')"
      :rules="[() => !!group.group_name || $t('group') + $t('required')]"
      :disabled="$store.getters['app/isTenant']"
    >
      <template slot="item" slot-scope="data">
        {{ data.item }} {{ data.item === "Drivers" ? $t("guest_driver") : "" }}
        {{ data.item === "One-time parking" ? $t("guest_onetime") : "" }}
        {{ data.item === "Over-parking guests" ? $t("guest_limited") : "" }}
      </template>
    </v-combobox>
    <div class="quota-wrapper" v-if="!$store.getters['app/isTenant']">
      <v-checkbox
        :label="$t('set_quota')"
        v-model="isQuotaSet"
        class="filter-checkbox"
      />
      <v-text-field
        v-if="isQuotaSet"
        type="number"
        min="1"
        v-model.number="quota"
        class="modal-input"
        :label="$t('spaces_number')"
        @blur="handleQuotaBlur"
      />
    </div>
  </v-form>
</template>

<script>
export default {
  name: "Group",
  props: {
    group: {
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      isQuotaSet: false,
      quota: 1,
    };
  },
  computed: {
    allGroups() {
      return this.$store.state.guests.groups;
    },
    groups() {
      let groups = [...this.allGroups].map((g) => g.group_name);
      let initList = [...groups]
        .slice()
        .sort((a, b) => a.localeCompare(b))
        .filter((i) => !i.includes("Drivers") && !i.includes("One-time parking"));
      let firstList = [...groups]
        .slice()
        .filter((i) => i.includes("Drivers") || i.includes("One-time parking"))
        .sort((a, b) => b.localeCompare(a));
      return firstList.concat(initList);
    },
    place() {
      return this.$store.state.app.places[0].place_id;
    },
    specialFlow() {
      let group = this.group.group_name;
      return (
        group.includes("Drivers") ||
        group.includes("Customers") ||
        group.includes("One-time") ||
        ((group.includes("Discounted") || group.includes("VIP") || group === "Monthly") &&
          this.place === 3146)
      );
    },
  },
  watch: {
    isQuotaSet(value) {
      if (value) {
        this.$emit('changeQuota', this.quota)
      } else {
        this.$emit('changeQuota', null)
      }
    },
    quota(value) {
      this.$emit('changeQuota', value)
    }
  },
  methods: {
    handleQuotaBlur() {
      if (!this.quota) {
        this.quota = 1
      }
    }
  },
  beforeMount() {
    if (this.group?.space_limit) {
      this.isQuotaSet = true;
      this.quota = this.group.space_limit;
    }
  }
};
</script>

<style lang="scss" scoped>
.quota-wrapper {
  display: flex;
  align-items: center;
}
.filter-checkbox {
  flex-shrink: 0;
  margin-right: 12px;
}
</style>
